import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Linkedin } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_trust-risk-scanner/artifacts/hba274xy_54B4EC9E-BB10-4795-9462-EE34138F48D0.png';

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { label: 'Home', path: '/' },
    { label: 'Run Scan', path: '/scan' },
    { label: 'Talk to Gateway', path: '/gateway' },
    { label: 'Submit Details', path: '/submit' },
    { label: 'About', path: '/about' },
    { label: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="no-print fixed top-0 left-0 right-0 z-50 bg-[#0B0B0D]/95 backdrop-blur-md border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
            <img 
              src={LOGO_URL} 
              alt="Subsurface" 
              className="h-8 transition-transform group-hover:scale-105"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium transition-colors ${
                  isActive(item.path)
                    ? 'text-[#FF6A00]'
                    : 'text-white/70 hover:text-[#FF6A00]'
                }`}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, '-')}`}
              >
                {item.label}
              </Link>
            ))}
            
            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/company/subsurface-qa-risk/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/70 hover:text-[#FF6A00] transition-colors"
              aria-label="LinkedIn"
              data-testid="nav-linkedin"
            >
              <Linkedin className="w-5 h-5" />
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-white"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-white/5">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`block py-3 text-sm font-medium transition-colors ${
                  isActive(item.path)
                    ? 'text-[#FF6A00]'
                    : 'text-white/70 hover:text-[#FF6A00]'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <a
              href="https://www.linkedin.com/company/subsurface-qa-risk/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 py-3 text-sm font-medium text-white/70 hover:text-[#FF6A00] transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              <Linkedin className="w-4 h-4" />
              LinkedIn
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
